import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core'
import { InputSourceDetector } from '../detectors/input-source.detector'
import { TrackedBarcodeMode } from '../models/tracked-barcode.types'

export interface InputSubmit {
  value: string
  mode: TrackedBarcodeMode | undefined
}

@Directive({
  selector: 'input[opInputSource]',
  exportAs: 'opInputSource',
  standalone: true,
})
export class InputSourceDirective {
  @Input() maxIntervalMs = 50
  @Input() minChars = 3
  @Output() opSubmit = new EventEmitter<InputSubmit>()

  private detector?: InputSourceDetector

  constructor(private readonly el: ElementRef<HTMLInputElement>) {}

  private get d(): InputSourceDetector {
    return (this.detector ??= new InputSourceDetector({
      maxIntervalMs: this.maxIntervalMs,
      minChars: this.minChars,
    }))
  }

  @HostListener('keydown', ['$event'])
  onKeydown(e: KeyboardEvent): void {
    if (e.isComposing) return
    this.d.keydown(e)
    if (e.key === 'Enter') {
      const value = this.el.nativeElement.value
      this.opSubmit.emit({ value, mode: this.d.evaluate(value, true) })
      this.d.reset()
    }
  }

  @HostListener('input', ['$event'])
  onInput(e: Event): void {
    this.d.input(e, this.el.nativeElement.value)
  }

  evaluate(): TrackedBarcodeMode | undefined {
    return this.d.evaluate(this.el.nativeElement.value, false)
  }

  reset(): void {
    this.d.reset()
  }
}
